import { render, staticRenderFns } from "./DialogTemplate.vue?vue&type=template&id=6f0e0bce&scoped=true"
import script from "./DialogTemplate.vue?vue&type=script&lang=js"
export * from "./DialogTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0e0bce",
  null
  
)

export default component.exports